// NEXUS -- registers this device for real, off-site push notifications
// (incoming calls + message alerts) once a user is logged in.
// Best-effort everywhere: a user who denies the permission prompt, or a
// browser without Push API support, should never see an error -- they just
// keep getting in-app notifications only, same as before this existed.
import api from "./api";

function urlBase64ToUint8Array(base64Url) {
  const padding = "=".repeat((4 - (base64Url.length % 4)) % 4);
  const base64 = (base64Url + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export async function registerPushNotifications() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) return;
  try {
    const reg = await navigator.serviceWorker.register("/sw.js");
    let sub = await reg.pushManager.getSubscription();
    if (!sub) {
      if (Notification.permission === "default") {
        const perm = await Notification.requestPermission();
        if (perm !== "granted") return;
      }
      if (Notification.permission !== "granted") return;
      const { data } = await api.get("/push/vapid-public-key");
      sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlBase64ToUint8Array(data.key),
      });
    }
    await api.post("/push/subscribe", sub.toJSON());
  } catch (e) {
    // Best-effort -- permission denied, unsupported browser, or a transient
    // network error should never block login or app usage.
  }
}
